$(function() {
  var locationPathname = location.pathname;
  var directories = locationPathname.split("/");
  var $link = $('.st-CategoryNav_Link');
  var $parent = $('.st-CategoryNav_Parent');
  var directories = locationPathname.split("/");
  var category = '/' + directories[1] + '/';
  var thirdLabel = '/' + directories[1] + '/' + directories[2] + '/' + directories[3] + '/';
  var fourthLabel = '/' + directories[1] + '/' + directories[2] + '/' + directories[3] + '/' + directories[4] + '/';

  var init = function() {
    addCurrentLink();
    addCurrentParent();
  }();

  /**
   * URLと同じリンクに`aria-current`を追加します。
   */
  function addCurrentLink() {
    $link.each(function(index, elm) {
      var href = $(elm).attr('href');

      if (locationPathname === href) {
        // 同じURLであればカレント表示する
        $(elm).attr('aria-current', 'page');
      }
    });
  }

  /**
   * URLと同じリンクか、親に当たるリンクに`aria-current`を追加します。
   */
  function addCurrentParent() {
    $parent.each(function(index, elm) {
      var $elm = $(elm);
      var href = $elm.attr('href');
      var isThirdLabelLocation = thirdLabel === href;
      var isFourthLocation = fourthLabel === href;
      var isPage = location.pathname.replace(/index\.html$/, '') === href;

      if (isPage) {
        $elm.attr('aria-current', 'page');
        return;
      }

      if (isThirdLabelLocation || isFourthLocation) {
        $elm.attr('aria-current', 'location');
      }
    });
  }

}());
